import { useDebouncedBroadcastFilters } from '@/hooks/use-debounced-broadcast-filters';
import {
  ProgramBroadcastFiltersState,
  useProgramBroadcastFilters,
} from '@/stores/program-broadcast-filters';

export type TClipListFilters = Partial<ProgramBroadcastFiltersState>;

/**
 * The filters the clips list of `/app/review/clips` is requested with, the
 * multi-value ones debounced as the list debounces them. Whatever has to act on
 * "the clips the list shows" (the list itself, the selection reset, the
 * sponsorship report under "select all") reads them from here, so all of them
 * ask for the same set.
 */
export function useClipListFilters(): TClipListFilters {
  const {
    logos,
    review_states,
    time_keeping_states,
    gte,
    lte,
    search,
    broadcasters,
    programs,
    people,
    channelType,
    startDatetimeGte,
    endDatetimeLte,
    workspaces,
    clients,
    projects,
    tags,
    order_by,
  } = useProgramBroadcastFilters();

  const debounced = useDebouncedBroadcastFilters({
    logos,
    people,
    programs,
    broadcasters,
    workspaces,
    projects,
    tags,
  });

  return {
    logos: debounced.logos,
    review_states,
    time_keeping_states,
    gte,
    lte,
    search,
    broadcasters: debounced.broadcasters,
    programs: debounced.programs,
    people: debounced.people,
    channelType,
    startDatetimeGte,
    endDatetimeLte,
    workspaces: debounced.workspaces,
    clients,
    projects: debounced.projects,
    tags: debounced.tags,
    order_by,
  };
}
